import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { ApplicationState } from '../../../store/reducers';
import * as RecoveryMethodsActions from '../../store/actions/password-recovery-management.actions';
import { getRecoveryMethodError } from '../../../store/reducers/index';
import { Subscription } from 'rxjs';

@Component({
  selector: 'mprd-email-add-container',
  templateUrl: 'email-add-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmailAddContainerComponent implements OnInit, OnDestroy {
  showAddMail: boolean;
  showLoadingSpinner: boolean;
  $getRecoveryMethodError: Subscription;

  constructor(
    private store: Store<ApplicationState>,
    private changeDetector: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.$getRecoveryMethodError = this.store
      .select(getRecoveryMethodError)
      .subscribe(() => {
        this.showLoadingSpinner = false;
        this.changeDetector.markForCheck();
      });
  }

  ngOnDestroy() {
    this.$getRecoveryMethodError.unsubscribe();
  }

  onValidEmailSubmit(emailId: string) {
    this.showLoadingSpinner = true;
    this.store.dispatch(
      new RecoveryMethodsActions.SetEmailRecoveryMethodAction(emailId),
    );
  }

  onEmailSubmitCancel() {
    this.toggleShowAddMail();
  }

  public toggleShowAddMail() {
    this.showAddMail = !this.showAddMail;
  }
}
